function canReadWindow() {
    return typeof window !== 'undefined';
}
export function isSupportChatDebugEnabled() {
    if (!canReadWindow())
        return false;
    const host = window.location.hostname.toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1')
        return true;
    const params = new URLSearchParams(window.location.search);
    const flag = params.get('supportChatDebug')?.toLowerCase();
    return flag === '1' || flag === 'true' || flag === 'yes';
}
export function supportChatDebug(message, meta) {
    if (!isSupportChatDebugEnabled())
        return;
    if (meta) {
        console.log(`[support-chat] ${message}`, meta);
        return;
    }
    console.log(`[support-chat] ${message}`);
}
export function supportChatWarn(message, meta) {
    if (meta) {
        console.warn(`[support-chat] ${message}`, meta);
        return;
    }
    console.warn(`[support-chat] ${message}`);
}
